import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT } from "@/data/products";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/products", label: "Catalogue" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <header data-testid="site-header" className="fixed inset-x-0 top-0 z-50 border-b border-black/10 bg-[#FAFAF7]/80 backdrop-blur-xl">
      <div className="mx-auto flex h-[72px] max-w-[1440px] items-center justify-between px-5 md:px-10">
        <Logo />
        <nav className="hidden items-center gap-9 md:flex">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) => `group relative font-mono text-xs uppercase tracking-[0.2em] transition-colors ${isActive ? "text-[#0B0B0B]" : "text-zinc-600 hover:text-[#0B0B0B]"}`}>
              {({ isActive }) => (<>
                {n.label}
                <span className={`absolute -bottom-1.5 left-0 h-[2px] bg-[#FF5A00] transition-[width] duration-500 ${isActive ? "w-full" : "w-0 group-hover:w-full"}`} />
              </>)}
            </NavLink>
          ))}
        </nav>
        <a href={`tel:${CONTACT.tel}`} data-testid="header-call-btn"
          className="hidden items-center gap-2 bg-[#0B0B0B] px-5 py-3 font-mono text-xs uppercase tracking-[0.15em] text-white transition-colors duration-300 hover:bg-[#FF5A00] md:flex">
          <Phone className="h-3.5 w-3.5" /> Call us
        </a>
        <button data-testid="mobile-menu-toggle" onClick={() => setOpen((o) => !o)} className="grid h-11 w-11 place-items-center bg-[#0B0B0B] text-white md:hidden" aria-label="Menu">
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav data-testid="mobile-menu" initial={{ height: 0 }} animate={{ height: "auto" }} exit={{ height: 0 }}
            transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }} className="overflow-hidden border-t border-black/10 bg-[#FAFAF7] md:hidden">
            <div className="flex flex-col px-5 py-6">
              {NAV.map((n, i) => (
                <NavLink key={n.to} to={n.to} end data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                  className="font-wide flex items-baseline gap-4 border-b border-black/10 py-4 text-2xl font-black uppercase">
                  <span className="font-mono text-xs text-[#FF5A00]">0{i + 1}</span>{n.label}
                </NavLink>
              ))}
              <a href={`tel:${CONTACT.tel}`} data-testid="mobile-call-btn" className="mt-6 bg-[#FF5A00] px-5 py-4 text-center font-mono text-sm uppercase tracking-[0.15em] text-white">
                Call {CONTACT.phone}
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
